import { useRef } from 'react'
import { useLockEdit } from 'contexts/PatientLockEditProvider'

const usePatientEditLock = () => {
  const { isLocked = false } = useLockEdit() || {}
  // Registered save callbacks and unmount cleanup must read the latest lock.
  const isLockedRef = useRef(isLocked)
  isLockedRef.current = isLocked

  return { isLocked, isLockedRef }
}

export default usePatientEditLock
